import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import SelectorImage from "../../form/SelectorGrid/SelectorImage";

class imageList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                type={SelectorImage}
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "imageGallery"}
                {...props}
                columns={{
                    "id": {header: 'Kód', width: 3, sortable, filterable},
                    "path": {header: 'Útvonal', width: 3, sortable, filterable},
                    "name": {header: 'Név', width: 3, sortable, filterable},
                    "url": {header: 'Url', width: 3, sortable, filterable},
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default imageList;
